var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{attrs:{"loading":_vm.is.loading}},[_c('app-content-head',{attrs:{"title":"Overview"}}),(!_vm.is.loading)?_c('app-content-body',{staticClass:"overview"},[_c('com-days',{attrs:{"days":_vm.data.days}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }